import { render, staticRenderFns } from "./AcceptContractButton.vue?vue&type=template&id=2d3dd519&"
import script from "./AcceptContractButton.vue?vue&type=script&lang=js&"
export * from "./AcceptContractButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports